import * as React from "react";
import { useDispatch } from "@teamprevent/admin-redux";
import { Table } from "semantic-ui-react";

import { CustomQuestionConfig, getQuestionTypeText } from "@teamprevent/common/questionnaires/questionnaireConfig/models";
import { ConfirmedButton } from "@teamprevent/common/confirmedButton/ConfirmedButton";

import { questionnaireConfigRemoveAdditionalQuestion } from "../actions";

interface Props {
    customerId: string;
    questionnaireType: string;
    questions: CustomQuestionConfig[];
}

export const AdditionalQuestionsDetails: React.FunctionComponent<Props> = (props: Props) => {

    const dispatch = useDispatch();

    const deleteQuestion = (questionId: string) => {
        if (!props.customerId || !props.questionnaireType || !questionId) {
            return;
        }

        dispatch(questionnaireConfigRemoveAdditionalQuestion(props.customerId, props.questionnaireType, questionId));
    };

    if (props.questions?.length > 0) {
        return (
            <Table>
                <Table.Header>
                    <Table.HeaderCell width={4} textAlign="center">Question</Table.HeaderCell>
                    <Table.HeaderCell width={2} textAlign="center">Question Type</Table.HeaderCell>
                    <Table.HeaderCell width={4} textAlign="center">Answer</Table.HeaderCell>
                    <Table.HeaderCell width={2} textAlign="center">Mandatory</Table.HeaderCell>
                    <Table.HeaderCell width={4} textAlign="center"></Table.HeaderCell>
                </Table.Header>
                <Table.Body>
                    {props.questions.map(question =>
                        (<Table.Row key={question.id}>
                            <Table.Cell textAlign="center">{question.questionText}</Table.Cell>
                            <Table.Cell textAlign="center">{getQuestionTypeText(question)}</Table.Cell>
                            <Table.Cell textAlign="center">{question.options && question.options.join(", ")}</Table.Cell>
                            <Table.Cell textAlign="center">{question.isMandatory ? "Yes" : "No"}</Table.Cell>
                            <Table.Cell textAlign="right">
                                <ConfirmedButton
                                    icon="delete"
                                    content="Remove question"
                                    className="warning"
                                    onClick={() => deleteQuestion(question.id)}
                                    promptText="Are you sure you want to delete this question?"
                                    headingText="Delete question"
                                />
                            </Table.Cell>
                        </Table.Row>)
                    )}
                </Table.Body>
            </Table>
        );
    }

    return null;
};
